/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreCommonalities = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M10.5 3.5c-.925 0-1.785.281-2.5.76a4.5 4.5 0 1 0 0 7.48 4.5 4.5 0 1 0 2.5-8.24zM8 10.442a3.484 3.484 0 0 1 0-4.884 3.484 3.484 0 0 1 0 4.884zM2 8c0-1.93 1.57-3.5 3.5-3.5.62 0 1.195.176 1.701.46C6.462 5.762 6 6.824 6 8s.462 2.238 1.201 3.04c-.506.284-1.08.46-1.701.46C3.57 11.5 2 9.93 2 8zm8.5 3.5c-.62 0-1.195-.176-1.701-.46C9.538 10.238 10 9.176 10 8s-.462-2.238-1.201-3.04A3.459 3.459 0 0 1 10.5 4.5C12.43 4.5 14 6.07 14 8s-1.57 3.5-3.5 3.5z"
    />
  </svg>
);

IconCoreCommonalities.displayName = 'IconCoreCommonalities';

IconCoreCommonalities.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreCommonalities);
IconCoreCommonalities.displayName = 'IconCoreCommonalities';
